module.exports = __webpack_public_path__ + "img/logo-pocketorbit.2c06fd2c.png";